import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AppState } from '../../store/states/app.state';
import { ActivatedRoute, Router } from '@angular/router';
import { EncryptService } from '../../services/encrypt/encrypt.service';
import { MfeSourceLoaderService } from '../../mfe/services';
import { TranslateApplicationService } from '../../services/translate/translate-application.service';
import { MfeAttribute, MfeEvent, MfeFileSource } from '@rappi/rappi-mfe-tools';
import { MicroFrontendWrapperComponent } from '../../mfe/models/abstracts';
import { environment } from '../../../environments/environment';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-reports-mfe',
  templateUrl: '../../mfe/models/abstracts/MicroFrontendWrapper.html',
  styleUrls: ['../../mfe/models/abstracts/MicroFrontendWrapper.scss']
})
export class ReportsMfeComponent extends MicroFrontendWrapperComponent implements OnInit, OnDestroy {
  protected elName: string;
  protected mfeSources: MfeFileSource[];
  protected mfeAttributes: MfeAttribute[];
  protected mfeEvents: MfeEvent[];

  constructor(
    public readonly sourceLoader: MfeSourceLoaderService,
    public readonly cd: ChangeDetectorRef,
    public readonly encryptService: EncryptService,
    public readonly router: Router,
    public readonly activatedRoute: ActivatedRoute,
    public readonly store: Store<AppState>,
    public readonly translateApplicationService: TranslateApplicationService
  ) {
    super(sourceLoader, cd, encryptService, router, activatedRoute, store, translateApplicationService);
    this.elName = 'mtz-reports-mfe';
    this.url = environment.urlMtzReportsMfeSourceRoot;
  }
}
